export const name = 'rnProfile';
export default function rnProfile($q, $log, rnHttp, rnSession) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const AAA_SERVICE_NAME = 'aaa';
  const PROFILE_PATH = 'users/';
  const PROFILE_CONTEXT_PATH = 'users/context/';
  const PROFILE_ROLE_PATH = 'users/roles/';

  var service = {
    getProfile: getProfile,
    saveProfile: saveProfile,
    getProfileAccounts: getProfileAccounts,
    removeProfileAccount: removeProfileAccount,
    getProfileRoles: getProfileRoles,
    removeProfileRole: removeProfileRole
  };

  return service;

  ////////////////

  function getProfile() {
    return doAaaGet(PROFILE_PATH);
  }


  function saveProfile(profileData) {
    return doAaaPut(PROFILE_PATH, profileData);
  }


  function getProfileAccounts() {
    return doAaaGet(PROFILE_CONTEXT_PATH);
  }


  function removeProfileAccount(id) {
    var path = PROFILE_CONTEXT_PATH + id;
    // DJL - Why are we passing this ID as data when it's already part of the URL?
    return doAaaDeleteWithContent(path, id);
  }


  function getProfileRoles() {
    return doAaaGet(PROFILE_ROLE_PATH);
  }


  function removeProfileRole(id) {
    var path = PROFILE_ROLE_PATH + id;
    return doAaaDelete(path);
  }


  function doAaaGet(path, config = {}) {

    return rnSession.isAuthenticated()
      .then(auth => {
        if (auth) {
          return rnHttp.get(AAA_SERVICE_NAME, path, config)
            .then(resp => {
              $log.debug('Successful ' + path + ' request: ', resp.data);
              return $q.resolve(resp.data);
            })
            .catch(resp => {
              $log.debug('Failed ' + path + ' request: ' + resp);
              return $q.reject(resp);
            });
        } else {
          return $q.reject({status: 401, statusText: 'Unauthenticated'});
        }
      });
  }


  function doAaaPut(path, content) {
    return rnHttp.put(AAA_SERVICE_NAME, path, content);
  }


  function doAaaDeleteWithContent(path, content) {
    return rnHttp.delete(AAA_SERVICE_NAME, path, content);
  }


  function doAaaDelete(path) {
    return rnHttp.delete(AAA_SERVICE_NAME, path);
  }
}
